import { ContentSearchScreen } from 'app/features/content/search'

import {
  createSearchCategoriesQuery,
  mapToSearchCategories,
} from 'app/queries/search/search-categories'
import { GetServerSideProps } from 'next'

import { dehydrate, QueryClient } from 'react-query'
import { makeQuery } from 'app/hooks/use-query'
import { withAuthedPage } from '../../lib/session'
import { verifyUser } from 'lib/verify-user'

export const getServerSideProps: GetServerSideProps = withAuthedPage(
  async (context) => {
    const store = context.req?.userStore
    const redirect = verifyUser(store)
    if (redirect) return redirect

    const queryClient = new QueryClient()
    const query = createSearchCategoriesQuery()
    const variables = {}

    await queryClient.prefetchQuery(['query', query, variables], async () =>
      makeQuery(query, variables, mapToSearchCategories),
    )

    const dehydratedState = dehydrate(queryClient)

    return {
      props: {
        dehydratedState,
      },
    }
  },
)

export default function ContentSearchPage() {
  return <ContentSearchScreen />
}
